import React from "react";
import { Route, Switch } from "react-router-dom";

import CompanyHome from "./home";
import CompanyUser from "AppSrc/company/members/companyUser";
import CompanyMembers from "AppSrc/company/members/companyMembers";
import CompanyDetails from "./details";
import CompanyIndicators from "./indicators/";
import CompanyMap from "./map";

import CompanyExportPage from "storybook-dashboard/dashboard/export/company/page";
import MetricsCompleteReportPage from "storybook-dashboard/dashboard/health/metricscomplete";

import RecipientEmailReport from "traec-react/emails/report/recipientEmailReport";
import CompanyReport from "AppSrc/company/report/index";
import CompanyIndicatorTarget from "AppSrc/company/indicators/indicatorTarget";
import EmailSettings from "traec-react/emails/settings/index";
import EmailReport from "traec-react/emails/report";
import CompanyHealthPage from "./health";
import MetricsReportingTablePage from "./metrics";

import { useCompanyPermissions } from "storybook-dashboard/utils/hooks";

function CompanyPermissions({ children, requiresAdmin, requiredActions }) {
  const { permissions, actions, isAdmin, isLoading } = useCompanyPermissions();

  if (isLoading) return <div>Loading...</div>;

  const hasRequiredActions = requiredActions ? requiredActions.every((a) => actions.includes(a)) : true;
  const hasPermissions = permissions ? (requiresAdmin ? isAdmin : hasRequiredActions) : false;

  console.log("CompanyPermissions", { permissions, actions, isAdmin, isLoading }, hasRequiredActions, hasPermissions);

  if (!hasPermissions) {
    return <div className="alert alert-warning mt-3 text-center">You do not have permission to view this page.</div>;
  }

  return children;
}

export function CompanyRouter() {
  const { isAdmin, isLoading } = useCompanyPermissions();

  if (isLoading) return <div>Loading...</div>;

  return (
    <CompanyPermissions>
      <Switch>
        {/* there will only ever be one child in the Switch */}

        {/* Pages for Members, Invites and Auth */}
        <Route exact path={`/company/:_companyId/members`} component={CompanyMembers} />
        <Route exact path={`/company/:_companyId/user/:_userId`} component={CompanyUser} />

        {/* Pages for Editing the Company Details */}
        <Route exact path={`/company/:_companyId/details`} component={CompanyDetails} />

        {/* Pages for Editing the Company Details */}
        <Route exact path={`/company/:_companyId/indicators`} component={CompanyIndicators} />
        <Route exact path={`/company/:_companyId/indicator/:indicatorId/target`} component={CompanyIndicatorTarget} />

        {/* Pages for Generating a pdf of indicators and metrics at a company level */}
        <Route path={`/company/:_companyId/report/`} component={CompanyReport} />

        {/* Pages for report status healthcheck */}
        <Route path={`/company/:_companyId/health/`} component={CompanyHealthPage} />

        {/* Pages for exports */}
        <Route
          path={`/company/:_companyId/export/`}
          render={(props) => <CompanyExportPage {...props} isAdmin={isAdmin} />}
        />

        {/* Pages for report completedness by metrics page */}
        <Route path={`/company/:_companyId/metricscomplete/`} component={MetricsCompleteReportPage} />

        {/* Pages for aggregate company report */}
        <Route path={`/company/:_companyId/metrics/`} component={MetricsReportingTablePage} />

        {/* Route for the Company Map */}
        <Route exact path={`/company/:_companyId/map`} render={(props) => <CompanyMap {...{ ...props }} />} />

        {/* Pages for email statistics */}
        <Route exact path={`/company/:_companyId/email/settings`} component={EmailSettings} />
        <Route exact path={`/company/:_companyId/email/report`} component={EmailReport} />
        <Route exact path={`/company/:_companyId/email/report/:recipientId`} component={RecipientEmailReport} />

        {/* Default render homepage if no path matched */}
        <Route component={CompanyHome} />
      </Switch>
    </CompanyPermissions>
  );
}
